import { Module } from '../plugins/_application'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

var $ = jQuery

export default class Tooltips extends Module {
  ready (app) {
    tippy('[data-tippy-content]', {
      allowHTML: true,
      arrow: false,
    });
  }
}